module.exports = __webpack_public_path__ + "img/drawGift8.d8aef603.png";